/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContratFichierGridDto
 */
export interface ContratFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof ContratFichierGridDto
     */
    idcontratFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ContratFichierGridDto
     */
    idtypeContratFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ContratFichierGridDto
     */
    typeContratFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContratFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContratFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContratFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContratFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ContratFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the ContratFichierGridDto interface.
 */
export function instanceOfContratFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratFichierGridDtoFromJSON(json: any): ContratFichierGridDto {
    return ContratFichierGridDtoFromJSONTyped(json, false);
}

export function ContratFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontratFichier': !exists(json, 'idcontratFichier') ? undefined : json['idcontratFichier'],
        'idtypeContratFichier': !exists(json, 'idtypeContratFichier') ? undefined : json['idtypeContratFichier'],
        'typeContratFichier': !exists(json, 'typeContratFichier') ? undefined : json['typeContratFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function ContratFichierGridDtoToJSON(value?: ContratFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontratFichier': value.idcontratFichier,
        'idtypeContratFichier': value.idtypeContratFichier,
        'typeContratFichier': value.typeContratFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

